import {writable} from "svelte/store"
import {load} from "../shared/api.js"

function createStore(url){
  const { subscribe, set, update } = writable([]);
  let loaded = false
	return {
    subscribe,
    set,
    update,
    load: async (force) =>{
      if(!force && loaded) return // prevent loading twice
      loaded = true
      set((await load({url})).data)
    }
	};
}

export const countries = createStore("/duocms/api/countries")
export const states = createStore("/duocms/api/states") 
export const session = createStore("/duocms/api/login") 